export const COOKIES = {
  REFRESH_TOKEN: 'refresh_token',
  USER_ID: 'userId',
  RECOVERY_EMAIL: 'recovery_email',
  VERIFICATION_CODE: 'verification_code',
  ANONYMOUS_TOKEN: 'anonymous_token',
};

export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX || 'avanta-app-';

export const CSV_MIME_TYPE = 'text/csv;charset=utf-8;';
